// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".value-badge{border-radius:1.5em;width:1.6em;height:1.6em;line-height:2em;box-sizing:content-box;line-height:1.6em;margin:0;font-weight:400}.value-badge.large{border-radius:2em;margin:auto!important;line-height:1em;font-size:6rem;border:6px solid}", ""]);
// Exports
module.exports = exports;
